((w) => {

    const assetId = 'gtm-ga4-prod-view';

    let userInfo = null;
    if (w.umwAssets && w.umwAssets[assetId] && w.umwAssets[assetId].length) {
        userInfo = w.umwAssets[assetId][0];
    }

    const utils = new GtmUtils();

    w.PubSub.subscribe('externaltracking.product.detailsview', (_, trackableProduct) => {
        if (!trackableProduct) { return; }
        const currencyCode = utils.getCurrencyCode();
        const gtmProduct = utils.convertToGtmGa4Product(trackableProduct, { 'currency': currencyCode });

        if (!gtmProduct) { return; }

        const productViewEvent = {
            'event': 'view_item',
            'ecommerce': {
                'currency': currencyCode,
                'items': [gtmProduct]
            }
        };

        if (userInfo) {
            productViewEvent.user = userInfo;
        }

        w.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        w.dataLayer.push(productViewEvent);
    });
})(window);